import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

console.log('🚀 index.tsx loaded');

const rootElement = document.getElementById('root');
console.log('Root element found:', !!rootElement);

if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);
  console.log('Creating React root...');
  
  root.render(<App />);
  
  console.log('React app rendered');
} else {
  console.error('❌ Root element not found!');
}